<template>
    <div id="ProfileSettings">
        <header>
            <VuiButton type="text" class="btn" @click.native="$router.go(-1)">返回</VuiButton>
            <p class="title">修改名字</p>
            <VuiButton type="text" class="btn" style="visibility: hidden;">完成</VuiButton>
        </header>
        <main>
            <section>
                <label>姓名</label>
                <input v-focus :value="userName" placeholder="请输入姓名" @input="inpuField" data-field="userName"></input>
            </section>
        </main>
        <footer>
            <section>
                <VuiButton type="text" class="btn" @click.native="submit">确定修改</VuiButton>
            </section>
        </footer>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
    import router from '@/router'

    export default {
        name: 'userName',
        data() {
            return {
                userName: this.$route.params.userName,
                userNameCursor: 0,
                loading: false,
            }
        },
        created() {
        },
        methods: {
            submit: function () {
                const param = {};
                param.userName = this.userName;
                if (param.userName.length < 2 || param.userName.length > 8) {
                    router.app.$Message.error('请输入2到8位的姓名')
                    return false;
                }
                this.loading = true;
                this.$store.dispatch('user/updateUser', param).then(res => {
                    this.loading = false;
                    router.app.$Message.info('成功修改用户名')
                    this.$router.go(-1)
                })
            },
            inpuField: function (e) {
                let field = e.currentTarget.dataset.field;
                let value = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
                if (field === 'userName') {
                    this.userName = e.target.value;
                }
            },
            clear: function (e) {
                let field = e.currentTarget.dataset.field;
                if (field === 'userName') {
                    this.userName = '';
                }
            },
        }
    }
</script>

<style lang="scss">

    #ProfileSettings {
        min-height: 100vh;
        background-color: #f0f0f0;

        .btn {
            padding: 0;
            height: auto;
            background-color: transparent;
            font-size: 17px;
            line-height: 24px;
            font-weight: bold;
            color: #ed6c00;
        }

        .height-auto {
            height: auto;
        }

        section {
            padding: 11px 20px 11px 0;
            margin-left: 20px;
            border-bottom: 1px solid #e5e4e4;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &:last-child {
                border-bottom: none;
            }
        }

        header {
            padding: 10px 20px;
            display: flex;
            justify-content: space-between;
            background-color: #ffffff;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);

            .title {
                font-size: 17px;
                line-height: 24px;
                font-weight: bold;
            }
        }

        main {
            margin-top: 20px;
            background-color: #ffffff;
            border-top: 1px solid rgba(0, 0, 0, 0.15);
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);

            label {
                width: 120px;
                font-size: 16px;
                line-height: 22px;
                color: #000000;
                flex-shrink: 0;
                flex-grow: 0;
            }

            input,
            textarea {
                border: none;
                outline: none;
                margin: 0;
                padding: 0;
                font-size: 16px;
                line-height: 22px;
                letter-spacing: 0.3px;
                text-align: right;
                flex-shrink: 1;
                flex-grow: 1;
                background-color: transparent;
                resize: none;
            }
        }

        footer {
            margin-top: 20px;
            background-color: #ffffff;
            border-top: 1px solid rgba(0, 0, 0, 0.15);
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        }
    }
</style>
